import { useEffect, useState } from 'react';
import { useGetHistoriePrivateMutation } from '../api/AuftragAPI';
import { IAuftragHistorie } from '../types/Types';
import { formatToEuroDateTime } from '../util/DateUtils';

interface ThisProps {
  auftragUid: string,
}

const HinweisComponent: React.FC<ThisProps> = (props) => {

  const [getAuftragHistoriePrivate] = useGetHistoriePrivateMutation();

  const [historie, setHistorie] = useState<IAuftragHistorie[]>([]);

  useEffect(() => {
    getAuftragHistoriePrivate(props.auftragUid).unwrap().then((data) => setHistorie(data));
  }, []);

  return (
    <>
      <ul>
        {historie?.map((e, index) =>
          <li key={index}>{(e.datum !== null) ? formatToEuroDateTime(e.datum) : "--"} {e.text!!}</li>
        )}
      </ul>
    </>
  );
}

export default HinweisComponent;
